import { render, staticRenderFns } from "./PersonalList.vue?vue&type=template&id=89cf5148"
import script from "./PersonalList.vue?vue&type=script&lang=js"
export * from "./PersonalList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports